import React from "react";
import Dropdown from "../Dropdown/Dropdown.jsx";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../Context/AppContext.jsx";
import userHasPermission from "../../helpers/formTools/userHasPermission/index.js";

export default function DataDropdown(props) {
  const { defaultSelected } = props;
  const { userProfile} = useAppContext();
  const organization = JSON.parse(localStorage.getItem("organization"));
  const navigate = useNavigate();
  const dropdownItems = [];



  if(userHasPermission({
    userProfile,
    organization,
    resource: "USER",
    permission: "READ",
  })) {
    dropdownItems.push({
      label: "UTENTI",
      onClick: () => {
        navigate("/users");
      },
    });
  }


  if(userHasPermission({
    userProfile,
    organization,
    resource: "GROUP",
    permission: "READ",
  })) {
    dropdownItems.push({
      label: "GRUPPI",
      onClick: () => {
        navigate("/groups");
      },
    });
  }

  if(userHasPermission({
    userProfile,
    organization,
    resource: "ROLE",
    permission: "READ",
  })) {
    dropdownItems.push({
      label: "RUOLI",
      onClick: () => {
        navigate("/roles");
      },
    });
  }


  if(userHasPermission({
    userProfile,
    organization,
    resource: "ORGANIZATION",
    permission: "READ",
  })) {
    dropdownItems.push({
      label: "ORGANIZZAZIONI",
      onClick: () => {
        navigate("/organizations");
      },
    });
  }


  return (
    <Dropdown
      dropdownTexts={dropdownItems}
      defaultSelected={defaultSelected}
    />
  );
}
